﻿(function () {
  if (window.ysLocalizedGalleryLoaded) {
    if (window.ysSyncLocalizedGalleryThumbnails) {
      window.ysSyncLocalizedGalleryThumbnails(document);
    }
    return;
  }

  window.ysLocalizedGalleryLoaded = true;

  function syncLocalizedGalleryThumbnails(root) {
    (root || document).querySelectorAll('[data-js-product-gallery]').forEach(function (gallery) {
      gallery.querySelectorAll('.product-gallery-item[data-localized-thumbnail]').forEach(function (item) {
        var index = item.getAttribute('data-index');
        var thumbnail = gallery.querySelector(
          '.product-gallery__thumbnails .thumbnail[data-index="' + index + '"] img'
        );

        if (!thumbnail) return;

        thumbnail.src = item.getAttribute('data-localized-thumbnail');
        thumbnail.removeAttribute('srcset');

        var alt = item.getAttribute('data-localized-thumbnail-alt');
        if (alt) thumbnail.alt = alt;
      });
    });
  }

  function syncGallerySliderControls(root) {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

    (root || document).querySelectorAll('[data-js-product-gallery]').forEach(function (gallery) {
      var mainElement = gallery.querySelector('.product-gallery-item-slider.slick-initialized');
      var thumbnailElement = gallery.querySelector('.product-gallery-thumbnail-slider.slick-initialized');

      if (!mainElement || !thumbnailElement) return;

      var mainSlider = window.jQuery(mainElement);
      var thumbnailSlider = window.jQuery(thumbnailElement);

      if (!gallery.hasAttribute('data-ys-gallery-controls-bound')) {
        gallery.setAttribute('data-ys-gallery-controls-bound', 'true');
        gallery.addEventListener('click', function (event) {
          var thumbnail = event.target.closest('.thumbnail[data-index]');

          if (!thumbnail || !thumbnailElement.contains(thumbnail)) return;

          var targetIndex = parseInt(thumbnail.getAttribute('data-index'), 10);

          if (Number.isNaN(targetIndex)) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          mainSlider.slick('slickGoTo', targetIndex);
          thumbnailSlider.slick('slickGoTo', targetIndex);
        }, true);
      }

      mainSlider.off('afterChange.ysLocalizedGallery');
      mainSlider.on('afterChange.ysLocalizedGallery', function (event, slick, currentSlide) {
        gallery.querySelectorAll('.product-gallery__thumbnails .thumbnail[data-index]').forEach(function (thumbnail) {
          thumbnail.classList.toggle('active', thumbnail.getAttribute('data-index') === String(currentSlide));
        });

        thumbnailSlider.slick('slickGoTo', currentSlide);
      });
    });
  }

  function syncLocalizedGallery(root) {
    syncLocalizedGalleryThumbnails(root);
    syncGallerySliderControls(root);
  }

  window.ysSyncLocalizedGalleryThumbnails = syncLocalizedGalleryThumbnails;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncLocalizedGallery(document);
      window.setTimeout(function () { syncLocalizedGallery(document); }, 1200);
    });
  } else {
    syncLocalizedGallery(document);
    window.setTimeout(function () { syncLocalizedGallery(document); }, 1200);
  }

  document.addEventListener('shopify:section:load', function (event) {
    syncLocalizedGallery(event.target);
    window.setTimeout(function () { syncLocalizedGallery(event.target); }, 1200);
  });
}());

